import React from 'react'
import { Component } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import './DataSecurityPopup.scss'

interface IDataSecurityPopupProps extends WithTranslation {
  visible: boolean
  onClose: () => void
  onConfirm: () => void
}

class DataSecurityPopup extends Component<IDataSecurityPopupProps> {
  constructor(props: IDataSecurityPopupProps) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <>
        <div
          onClick={() => this.props.onClose()}
          className={['data-security', this.props.visible ? 'show' : ''].join(' ')}
        >
          <div className="popup popUserArea securityPopup" onClick={(e) => e.stopPropagation()}>
            <a className="closeBtn" onClick={() => this.props.onClose()}>
              <i className="icon-close" />
            </a>
            <div className="row userPref">
              <div className="col-12">
                <div className="popTitle">
                  <i className="icon-warning" />
                  <div>{this.props.t('DATA_SECURITY_POPUP_TITLE')}</div>
                  <i className="icon-warning" />
                </div>
                <div className="row flex">
                  <div className="col-3">
                    <img src="/security-alert.png" width="107" height="106" alt="Security Alert!"></img>
                  </div>
                  <div className="col-9">
                    {this.props.t('DATA_SECURITY_POPUP')}
                    <p>{this.props.t('DATA_SECURITY_POPUP_QUESTION')}</p>
                  </div>
                </div>
              </div>
              <div className="btnArea">
                <div onClick={() => this.props.onClose()} className="btn btnClose">
                  <i className="icon-close" /> {this.props.t('CANCEL')}
                </div>
                <div onClick={() => this.props.onConfirm()} className="btn btnOk">
                  <i className="icon-check" />
                  {this.props.t('CONFIRM')}
                </div>
              </div>
            </div>
          </div>
          <div className="blur"></div>
        </div>
      </>
    )
  }
}

export default withTranslation('common')(DataSecurityPopup)
